import { useContext, FC, useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
    Alert,
    Box,
    Button,
    FormHelperText,
    TextField,
} from "@material-ui/core";
import useAuth from "../../../hooks/useAuth";
import useMounted from "../../../hooks/useMounted";
import toast from "react-hot-toast";
// import adalProvider from "src/types/ADFS/adalProvider";
import { apiAdfsConfig } from 'src/config';
import { useAdal } from 'react-adal';
import { AuthContext } from "src/contexts/useAuthProvider ";
import { useNavigate } from 'react-router-dom';
import { getToken } from "src/hooks/useAuthProvider";

const LoginJWT: FC = (props) => {
    const mounted = useMounted();
    const { login, loginAdfs } = useAuth();

    const { loginSSO, logoutSSO } = useContext(AuthContext);

    const urlParams = new URLSearchParams(location.hash.substring(1));
    const idToken = urlParams.get('id_token');

    useEffect(() => {
        // Get the value of the 'id_token' parameter from the URL
        // const urlParams = new URLSearchParams(location.hash.substring(1));
        // const idToken = urlParams.get('id_token');
        if (idToken) {
            loginAdfs(idToken)
        }

    }, [idToken]);

    return (
        <Formik
            initialValues={{
                email: "",
                password: "",
                submit: null,
            }}
            validationSchema={Yup.object().shape({
                email: Yup.string()
                    //   .email('Must be a valid email')
                    .max(255)
                    .required("Tên đăng nhập là bắt buộc"),
                password: Yup.string()
                    .max(255)
                    //   .min(8, 'pass ít nhứt 8 kí tự')
                    .required("Mật khẩu là bắt buộc"),
            })}
            onSubmit={async (
                values,
                { setErrors, setStatus, setSubmitting }
            ): Promise<void> => {
                try {
                    await login(values.email.trim(), values.password);
                    if (mounted.current) {
                        setStatus({ success: true });
                        setSubmitting(false);
                    }
                } catch (err) {
                    if (mounted.current) {
                        setStatus({ success: false });
                        setErrors({ submit: err.response.data.message });
                        setSubmitting(false);
                        localStorage.removeItem("authorizationData");
                    }
                }
            }}
        >
            {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values,
            }): JSX.Element => (
                <form noValidate onSubmit={handleSubmit} {...props}>
                    <TextField
                        autoFocus
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        helperText={touched.email && errors.email}
                        label="Tên đăng nhập"
                        margin="normal"
                        name="email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="text"
                        value={values.email}
                        variant="outlined"
                    />
                    <TextField
                        error={Boolean(touched.password && errors.password)}
                        fullWidth
                        helperText={touched.password && errors.password}
                        label="Mật khẩu"
                        margin="normal"
                        name="password"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="password"
                        value={values.password}
                        variant="outlined"
                        placeholder="Mật khẩu"
                        autoComplete="on"
                    />
                    {errors.submit && (
                        <Box sx={{ mt: 3 }}>
                            <FormHelperText error>
                                {errors.submit}
                            </FormHelperText>
                        </Box>
                    )}
                    <Box sx={{ mt: 2 }}>
                        <Button
                            color="primary"
                            disabled={isSubmitting}
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                        >
                            Đăng nhập
                        </Button>
                    </Box>
                    <Box sx={{ mt: 2 }}>
                        <Button
                            // color="primary"
                            // disabled={isSubmitting}
                            fullWidth
                            size="large"
                            type="button"
                            variant="outlined"
                            onClick={loginSSO}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 48 48"
                                width="48px"
                                height="48px"
                            >
                                <path
                                    fill="#e64a19"
                                    d="M7 12L29 4 41 7 41 41 29 44 7 36 29 39 29 10 15 13 15 33 7 36z"
                                />
                            </svg>
                            Đăng nhập SSO
                        </Button>
                    </Box>
                    {/* <Box sx={{ mt: 2 }}>
            <Alert severity="info">
              <div>
                Use
                {' '}
                <b>demo@devias.io</b>
                {' '}
                and password
                {' '}
                <b>Password123!</b>
              </div>
            </Alert>
          </Box> */}
                </form>
            )}
        </Formik>
    );
};

export default LoginJWT;
